import React, { useEffect, useState } from "react";
import { Modal, Spin, Alert, Collapse, Tag, Empty } from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

import userService from "../../../../services/UserService";
import { useUser } from "../../../../context/UserContext";

const PERMISSION_LABELS = {
  isAllowedtoCreate: "Crear",
  isAllowedtoUpdate: "Editar",
  isAllowedtoDelete: "Eliminar",
  isAllowedtoSee: "Ver",
  isAllowedtoClose: "Cerrar",
  isAllowedtoLoadCost: "Asignar costo",
};

const MODULE_LABELS = {
  events: "Eventos",
  activities: "Actividades",
  protocols: "Protocolos",
  users: "Usuarios",
};

export default function ModalPermisosUsuario({ open, setOpen, item }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [permisos, setPermisos] = useState(null);
  const user = useUser();

  useEffect(() => {
    if (!open) return;

    const cargarPermisos = async () => {
      setLoading(true);
      setError(null);
      setPermisos(null);
      try {
        const data = await userService.consultarRolesUsuario(
          item?.role || "lector",
          user.idToken
        );
        setPermisos(data?.Item ?? data ?? {});
      } catch (err) {
        console.error("Error al consultar permisos del rol:", err);
        setError("No se logró consultar los permisos de este rol.");
      }
      setLoading(false);
    };

    cargarPermisos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, item]);

  const modulos = permisos ? Object.entries(permisos) : [];

  return (
    <Modal
      title={`Permisos — ${item?.name || ""} ${item?.lastName || ""} (${
        item?.role || "Sin rol"
      })`}
      open={open}
      onCancel={() => setOpen(false)}
      onOk={() => setOpen(false)}
      footer={null}
      destroyOnClose
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "24px 0" }}>
          <Spin />
        </div>
      )}

      {!loading && error && <Alert type="error" showIcon message={error} />}

      {!loading && !error && modulos.length === 0 && (
        <Empty description="Este rol no tiene permisos configurados" />
      )}

      {!loading && !error && modulos.length > 0 && (
        <Collapse
          defaultActiveKey={modulos.map(([modulo]) => modulo)}
          items={modulos.map(([modulo, permisosModulo]) => ({
            key: modulo,
            label: MODULE_LABELS[modulo] || modulo,
            children: (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {Object.entries(permisosModulo || {}).map(
                  ([permiso, activo]) => (
                    <Tag
                      key={permiso}
                      icon={
                        activo ? <CheckCircleFilled /> : <CloseCircleFilled />
                      }
                      color={activo ? "success" : "default"}
                    >
                      {PERMISSION_LABELS[permiso] || permiso}
                    </Tag>
                  )
                )}
              </div>
            ),
          }))}
        />
      )}
    </Modal>
  );
}
